import type { MenuItem } from '@/cms/fields/types/common';

// This is mock data for the menu, based on the Sitecore structure
export default {
  text: 'Ons aanbod',
  children: [
    {
      text: 'Zonvakanties',
      children: [
        { text: 'Homepage', href: '/vakantie' },
        { text: 'Zoek en boek', href: '/vakantie/zoeken' },
        {
          text: 'Bestemmingen',
          children: [
            { text: 'Alle bestemmingen', href: '/vakantie' },
            { text: 'België', href: '/vakantie/belgie' },
            { text: 'Bulgarije', href: '/vakantie/bulgarije' },
            { text: 'Cyprus', href: '/vakantie/cyprus' },
            { text: 'Duitsland', href: '/vakantie/duitsland' },
            { text: 'Egypte', href: '/vakantie/egypte' },
            { text: 'Frankrijk', href: '/vakantie/frankrijk' },
            { text: 'Griekenland', href: '/vakantie/griekenland' },
            { text: 'Italië', href: '/vakantie/italie' },
            { text: 'Kroatië', href: '/vakantie/kroatie' },
            { text: 'Marokko', href: '/vakantie/marokko' },
            { text: 'Montenegro', href: '/vakantie/montenegro' },
            { text: 'Nederland', href: '/vakantie/nederland' },
            { text: 'Oostenrijk', href: '/vakantie/oostenrijk' },
            { text: 'Portugal', href: '/vakantie/portugal' },
            { text: 'Spanje', href: '/vakantie/spanje' },
            { text: 'Tunesië', href: '/vakantie/tunesie' },
            { text: 'Turkije', href: '/vakantie/turkije' },
          ],
        },
        {
          text: 'Aanbiedingen',
          children: [
            { text: 'Aanbiedingen', href: '/vakantie/deals' },
            { text: 'Early booking', href: '/vakantie/vroegboek' },
            { text: 'Last minute', href: '/vakantie/last-minutes' },
          ],
        },
        {
          text: 'Vakantieperiodes',
          children: [
            { text: 'Voorjaarsvakantie', href: '/vakantie/voorjaarsvakantie' },
            { text: 'Meivakantie', href: '/vakantie/meivakantie' },
            { text: 'Zomervakantie', href: '/vakantie/zomervakantie' },
            { text: 'Nazomer', href: '/vakantie/nazomer' },
            { text: 'Herfstvakantie', href: '/vakantie/herfstvakantie' },
            { text: 'Kerstvakantie', href: '/vakantie/kerstvakantie' },
            { text: 'Winterzon', href: '/vakantie/winterzon' },
          ],
        },
        {
          text: 'Type verblijf',
          children: [
            { text: 'Alle verblijven', href: '/vakantie/verblijf' },
            { text: 'Aparthotel', href: '/vakantie/verblijf/aparthotel' },
            { text: 'Appartement', href: '/vakantie/verblijf/appartement' },
            { text: 'Bungalow', href: '/vakantie/verblijf/bungalow' },
            { text: 'Hotel', href: '/vakantie/verblijf/hotel' },
            { text: 'Vakantiepark', href: '/vakantie/verblijf/vakantiepark' },
            { text: 'Villa', href: '/vakantie/verblijf/villa' },
          ],
        },
        {
          text: 'Themas',
          children: [
            { text: 'All inclusive', href: '/vakantie/all-inclusive' },
            { text: 'Familievakanties', href: '/vakantie/familievakanties' },
            { text: 'Adults only', href: '/vakantie/adults-only' },
            { text: 'Romantisch', href: '/vakantie/romantisch' },
            { text: 'Groepsreizen', href: '/vakantie/groepsreizen' },
            { text: 'Fly and drive', href: '/vakantie/fly-drive' },
            { text: 'Kleinschalig', href: '/vakantie/kleinschalig' },
            { text: 'Stedentrips', href: '/vakantie/stedentrips' },
            { text: 'Workation', href: '/vakantie/workation' },
          ],
        },
        {
          text: 'Sunweb labels',
          children: [
            { text: 'Alle labels', href: '/vakantie/labels' },
            { text: 'Boutique', href: '/vakantie/labels/boutique' },
            { text: 'Excellent', href: '/vakantie/labels/excellent' },
            { text: 'Secrets', href: '/vakantie/labels/secrets' },
            { text: 'Selections', href: '/vakantie/labels/selections' },
            { text: 'Villages', href: '/vakantie/labels/villages' },
            { text: 'Primavera', href: '/vakantie/labels/primavera' },
          ],
        },
        {
          text: 'Vliegtickets',
          children: [
            { text: 'Alle vliegtickets', href: '/vakantie/vliegtickets' },
            { text: 'Vliegtickets Egypte', href: '/vakantie/vliegtickets/egypte' },
            { text: 'Vliegtickets Griekenland', href: '/vakantie/vliegtickets/griekenland' },
            { text: 'Vliegtickets Portugal', href: '/vakantie/vliegtickets/portugal' },
            { text: 'Vliegtickets Spanje', href: '/vakantie/vliegtickets/spanje' },
            { text: 'Vliegtickets Tunesië', href: '/vakantie/vliegtickets/tunesie' },
            { text: 'Vliegtickets Turkije', href: '/vakantie/vliegtickets/turkije' },
          ],
        },
        {
          text: 'Vliegen vanaf',
          children: [
            { text: 'Alle luchthavens', href: '/luchthavens' },
            { text: 'Amsterdam', href: '/luchthavens/schiphol' },
            { text: 'Eindhoven', href: '/luchthavens/eindhoven-airport' },
            { text: 'Rotterdam', href: '/luchthavens/rotterdam-the-hague' },
            { text: 'Groningen', href: '/vakantie/zoeken?DepartureAirport%5B0%5D=GRQ' },
            { text: 'Brussels', href: '/luchthavens/brussels-airport' },
            { text: 'Weeze', href: '/luchthavens/weeze' },
            { text: 'Düsseldorf', href: '/vakantie/zoeken?DepartureAirport%5B0%5D=DUS' },
            { text: 'Köln', href: '/vakantie/zoeken?DepartureAirport%5B0%5D=CGN' },
          ],
        },
      ],
    },
    {
      text: 'Wintersport',
      children: [
        { text: 'Homepage', href: '/wintersport' },
        { text: 'Zoek en boek', href: '/wintersport/zoeken' },
        {
          text: 'Bestemmingen',
          children: [
            { text: 'Alle bestemmingen', href: '/wintersport/bestemmingen' },
            { text: 'Oostenrijk', href: '/wintersport/oostenrijk' },
            { text: 'Andorra', href: '/wintersport/andorra' },
            { text: 'Frankrijk', href: '/wintersport/frankrijk' },
            { text: 'Duitsland', href: '/wintersport/duitsland' },
            { text: 'Italië', href: '/wintersport/italie' },
            { text: 'Noorwegen', href: '/wintersport/noorwegen' },
            { text: 'Zweden', href: '/wintersport/zweden' },
            { text: 'Zwitserland', href: '/wintersport/zwitserland' },
          ],
        },
        {
          text: 'Wintersport aanbiedingen',
          children: [
            { text: 'Vroegboek', href: '/wintersport/vroegboek' },
            { text: 'Last minutes', href: '/wintersport/last-minutes' },
            { text: 'Black Friday', href: '/wintersport/black-friday' },
            { text: 'Snow deals', href: '/wintersport/snowdeals' },
            { text: 'Goedkoop', href: '/wintersport/goedkoop' },
          ],
        },
        {
          text: 'Sunweb labels',
          children: [
            { text: 'Totally snow', href: '/wintersport/totally-snow' },
            { text: 'Excellent', href: '/wintersport/collections/excellent' },
            { text: 'FamFun', href: '/wintersport/famfun' },
            { text: 'Secrets', href: '/wintersport/collections/secrets' },
            { text: 'Selections', href: '/wintersport/collections/selections' },
          ],
        },
        {
          text: 'Vakantieperiodes',
          children: [
            { text: 'Kerstvakantie', href: '/wintersport/kerstvakantie' },
            { text: 'Oud en nieuw', href: '/wintersport/oud-en-nieuw' },
            { text: 'Voorjaarsvakantie', href: '/wintersport/voorjaarsvakantie' },
            { text: 'Pasen', href: '/wintersport/pasen' },
          ],
        },
        {
          text: 'Evenementen',
          children: [
            { text: 'EGSW', href: '/wintersport/european-gay-ski-week' },
            { text: 'Dutchweek', href: '/wintersport/dutchweek' },
            { text: 'Dutchweek Festival Val Thorens', href: '/wintersport/dutchweek-festival' },
            { text: 'Tomorrowland Winter', href: '/wintersport/tomorrowland-winter' },
          ],
        },
        {
          text: 'Verblijf',
          children: [
            { text: 'Vaya resorts', href: '/wintersport/vaya-resorts' },
            { text: 'Appartement', href: '/wintersport/appartement' },
            { text: 'Catered chalets', href: '/wintersport/catered-chalets' },
            { text: 'Chalets', href: '/wintersport/chalets' },
            { text: 'Hotels', href: '/wintersport/hotels' },
          ],
        },
        {
          text: 'Vervoer',
          children: [
            { text: 'Bus', href: '/wintersport/busreis' },
            { text: 'Eigen vervoer', href: '/wintersport/eigen-vervoer' },
            { text: 'Vliegtuig', href: '/wintersport/vliegreis' },
          ],
        },
        {
          text: 'Groepen',
          children: [
            { text: 'Totally Snow', href: '/wintersport/groepsreizen/totally-snow' },
            { text: 'Groepen', href: '/wintersport/groepsreizen' },
          ],
        },
        {
          text: 'Themas',
          children: [
            { text: 'Totally snow', href: '/wintersport/totally-snow' },
            { text: 'Familie', href: '/wintersport/familie' },
            { text: 'FamFun', href: '/wintersport/famfun' },
            { text: 'Studenten', href: '/wintersport/studenten' },
            { text: 'Beginners', href: '/wintersport/beginners' },
            { text: 'Mini ski', href: '/wintersport/mini-ski' },
            {
              text: 'Wellness',
              href: '/wintersport/zoeken?Allocation=2&Participants%5B0%5D%5B0%5D=1990-03-20&Participants%5B0%5D%5B1%5D=1990-03-20&Participants%5B0%5D%5B2%5D=1990-03-20&Participants%5B0%5D%5B3%5D=1990-03-20&Duration%5B0%5D=8-10&Themes%5B0%5D=wellness&offset=0',
            },
            { text: 'Luxe', href: '/wintersport/luxe' },
          ],
        },
      ],
    },
    {
      text: 'Cruises',
      children: [
        { text: 'Homepage', href: '/cruises' },
        {
          text: 'Bestemmingen',
          children: [
            { text: 'Middellandse Zee', href: '/cruises/bestemmingen/middellandse-zee' },
            { text: 'Noorse fjorden', href: '/cruises/bestemmingen/noorse-fjorden' },
            { text: 'Caribbean', href: '/cruises/bestemmingen/caribbean' },
            { text: 'Noord-Europa', href: '/cruises/bestemmingen/noord-europa' },
            { text: 'Griekse eilanden', href: '/cruises/bestemmingen/griekse-eilanden' },
            { text: 'Alaska', href: '/cruises/bestemmingen/alaska' },
            { text: 'Toon alle bestemmingen', href: '/cruises/bestemmingen' },
          ],
        },
        {
          text: 'Rederijen',
          children: [
            { text: 'MSC Cruises', href: '/cruises/rederijen/msc-cruises' },
            { text: 'Costa Cruises', href: '/cruises/rederijen/costa-cruises' },
            { text: 'Holland America Line', href: '/cruises/rederijen/holland-america-line' },
            { text: 'Royal Carribean', href: '/cruises/rederijen/royal-caribbean' },
            { text: 'PO Cruises', href: '/cruises/rederijen/po-cruises' },
            { text: 'Toon alle rederijen', href: '/cruises/rederijen' },
          ],
        },
        {
          text: 'Vertrekhavens',
          children: [
            {
              text: 'Amsterdam',
              href: '/cruises/zoekactie?facetFilter%5BDeparturePortHierarchical.Level2%5D%5BNederland%20%3E%20Amsterdam%5D=Amsterdam&sortBy=default&pageNumber=0&pageSize=10&isActiveFlag=false',
            },
            {
              text: 'Rotterdam',
              href: '/cruises/zoekactie?facetFilter%5BDeparturePortHierarchical.Level2%5D%5BNederland%20%3E%20Rotterdam%5D=Rotterdam&sortBy=default&pageNumber=0&pageSize=10&isActiveFlag=false',
            },
            {
              text: 'Barcelona',
              href: '/cruises/zoekactie?facetFilter%5BDeparturePortHierarchical.Level2%5D%5BSpanje%20%3E%20Barcelona%5D=Barcelona&sortBy=default&pageNumber=0&pageSize=10&isActiveFlag=false',
            },
            {
              text: 'Kiel',
              href: '/cruises/zoekactie?facetFilter%5BDeparturePortHierarchical.Level2%5D%5BDuitsland%20%3E%20Kiel%5D=Kiel&sortBy=default&pageNumber=0&pageSize=10&isActiveFlag=false',
            },
            {
              text: 'Miami',
              href: '/cruises/zoekactie?facetFilter%5BDeparturePortHierarchical.Level2%5D%5BVerenigde%20Staten%20%3E%20Miami%5D=Miami&sortBy=default&pageNumber=0&pageSize=10&isActiveFlag=false',
            },
            {
              text: 'Marseille',
              href: '/cruises/zoekactie?facetFilter%5BDeparturePortHierarchical.Level2%5D%5BFrankrijk%20%3E%20Marseille%5D=Marseille&sortBy=default&pageNumber=0&pageSize=10&isActiveFlag=false',
            },
            {
              text: 'Genua',
              href: '/cruises/zoekactie?facetFilter%5BDeparturePortHierarchical.Level2%5D%5BItali%C3%AB%20%3E%20Genua%5D=Genua&sortBy=default&pageNumber=0&pageSize=10&isActiveFlag=false',
            },
            {
              text: 'Rome',
              href: '/cruises/zoekactie?facetFilter%5BDeparturePortHierarchical.Level2%5D%5BItali%C3%AB%20%3E%20Civitavecchia%20%28Rome%29%5D=Civitavecchia%20%28Rome%29&sortBy=default&pageNumber=0&pageSize=10&isActiveFlag=false',
            },
            {
              text: 'Fort Lauderdale',
              href: '/cruises/zoekactie?facetFilter%5BDeparturePortHierarchical.Level2%5D%5BVerenigde%20Staten%20%3E%20Fort%20Lauderdale%5D=Fort%20Lauderdale&sortBy=default&pageNumber=0&pageSize=10&isActiveFlag=false',
            },
          ],
        },
        {
          text: 'Vakantieperiodes',
          children: [
            { text: 'Voorjaarsvakantie', href: '/cruises/cruise-schoolvakanties/cruise-voorjaarsvakantie' },
            { text: 'Meivakantie', href: '/cruises/cruise-schoolvakanties/cruise-meivakantie' },
            { text: 'Zomervakantie', href: '/cruises/cruise-schoolvakanties/cruise-zomervakantie' },
            { text: 'Herfstvakantie', href: '/cruises/cruise-schoolvakanties/cruise-herfstvakantie' },
            { text: 'Kerstvakantie', href: '/cruises/cruise-schoolvakanties/cruise-kerstvakantie' },
          ],
        },
        {
          text: 'Themas',
          children: [
            { text: 'Cruise vanuit Nederland', href: '/cruises/vanuit-nederland' },
            { text: 'Last minute cruise', href: '/cruises/last-minute-cruise' },
            { text: 'All inclusive cruise', href: '/cruises/all-inclusive-cruise' },
            { text: 'Familie cruise', href: '/cruises/cruisevakantie-met-kinderen' },
            { text: 'Adults Only cruise', href: '/cruises/adults-only-cruise' },
            { text: 'Meer themas', href: '/cruises/cruise-type' },
          ],
        },
        {
          text: 'Vluchten',
          href: '/cruises/cruise-en-vlucht',
        },
      ],
    },
    {
      text: 'Autovakanties',
      children: [
        { text: 'Alle Autovakanties', href: '/autovakanties' },
        { text: 'Autovakanties België', href: '/autovakanties/belgie' },
        { text: 'Autovakanties Duitsland', href: '/autovakanties/duitsland' },
        { text: 'Autovakanties Frankrijk', href: '/autovakanties/frankrijk' },
        { text: 'Autovakanties Italië', href: '/autovakanties/italie' },
        { text: 'Autovakanties Kroatië', href: '/autovakanties/kroatie' },
        { text: 'Autovakanties Nederland', href: '/autovakanties/nederland' },
        { text: 'Autovakanties Oostenrijk', href: '/autovakanties/oostenrijk' },
        { text: 'Autovakanties Spanje', href: '/autovakanties/spanje' },
      ],
    },
    {
      text: 'Aanbiedingen',
      children: [
        {
          text: 'Zonvakanties',
          children: [
            {
              text: 'Aanbiedingen',
              href: '/vakantie/zoeken?Allocation=2&Discount%5B0%5D=promotion&Duration%5B0%5D=8-11&offset=0',
            },
            {
              text: 'Early booking',
              href: '/vakantie/vroegboek',
            },
            {
              text: 'Last minutes',
              href: '/vakantie/last-minutes',
            },
          ],
        },
        {
          text: 'Wintersport',
          children: [
            {
              text: 'Vroegboekdeals',
              href: '/wintersport/vroegboek',
            },
            {
              text: 'Last minutes',
              href: '/vakantie/last-minutes',
            },
            {
              text: 'Black Friday',
              href: '/vakantie/black-friday',
            },
            {
              text: 'Snow deals',
              href: '/wintersport/snowdeals',
            },
            {
              text: 'Goedkoop',
              href: '/wintersport/goedkoop',
            },
            {
              text: 'Alle winter aanbiedingen',
              href: '/wintersport/zoeken',
            },
          ],
        },
      ],
    },
    {
      text: 'Last minutes',
      children: [
        {
          text: 'Zon last minutes',
          href: '/vakantie/last-minutes',
        },
        {
          text: 'Wintersport last minutes',
          href: '/wintersport/last-minutes',
        },
      ],
    },
    {
      text: 'Extra',
      children: [
        {
          text: 'All extras',
          href: '/extras',
        },
        {
          text: 'Zonvakantie extras',
          children: [
            {
              text: 'Bagage bijboeken',
              href: '/vakantie/extras/bagage',
            },
            {
              text: 'Verzekeringen',
              href: '/verzekeringen',
            },
            {
              text: 'Transfer',
              href: '/vakantie/extras/transfer',
            },
            {
              text: 'Autohuur',
              href: '/vakantie/extras/autohuur',
            },
            {
              text: 'Excursies',
              href: 'https://www.excursions.sunweb.com/',
            },
            {
              text: 'Visum',
              href: '/vakantie/extras/visum',
            },
            {
              text: 'Stoelreservering',
              href: '/vakantie/extras/stoelreservering',
            },
            {
              text: 'Verzorging',
              href: '/vakantie/extras/verzorging',
            },
          ],
        },
        {
          text: 'Wintersport extras',
          children: [
            {
              text: 'Materiaal',
              href: '/wintersport/ski-materiaal',
            },
            {
              text: 'Skipas',
              href: '/wintersport/inclusief-skipas',
            },
            {
              text: 'Verzorging',
              href: '/wintersport/verzorgingstype',
            },
            {
              text: 'Lessen',
              href: '/wintersport/skilessen',
            },
          ],
        },
      ],
    },
  ],
} as MenuItem;

export const mockDataExtra = [
  { text: 'Inspiratie', href: '/blog' },
  { text: 'Last minutes', href: '/vakantie/last-minutes' },
  { text: 'Contact', href: 'https://service.sunweb.com/nl/support/home' },
] as MenuItem[];
